import React, { useEffect, useState } from "react";
import Header from "components/Header";
import Hero from "components/Hero";
import About from "components/About";
import Company from "components/Company";
import Services from "components/Services";
import CTA from "components/CTA";
import ChooseUs from "components/ChooseUs";
import Sidebar from "components/Sidebar";
import Contact from "components/Contact";
import Footer from "components/Footer";
import Gallery from "components/Gallery";

const App = () => {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const handleStart = () => setLoading(true);
		const handleComplete = () => setLoading(false);

		handleStart();
		setTimeout(handleComplete, 1000);

		return () => {
			handleComplete();
		};
	}, []);

	return (
		<>
			<Header />
			<Hero />
			<About />
			<Company />
			<Services />
			<CTA />
			<ChooseUs />
			<Sidebar />
			<Gallery />
			<Contact />
			<Footer />
			<div
				id="anywhere-home"
				onClick={() => {
					document.getElementById("anywhere-home").classList.remove("bgshow");
					document.getElementById("side-bar").classList.remove("show");
				}}></div>
		</>
	);
};

export default App;
